import React from 'react'

import { Button, Variants } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ContactModal from 'modules/billing/components/ContactModalPage'
import useContactSales from 'modules/billing/hooks/useContactSales'

type Props = {
  type?: Variants
  ctaLabel?: string
  contactReason?: 'upgrade' | 'default'
  emitEventHandler: () => void
  disabled?: boolean
}

const ContactButton = ({
  ctaLabel,
  type = 'primary',
  contactReason = 'default',
  disabled = false,
  emitEventHandler,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const isUpgradeRequested = contactReason === 'upgrade'
  const { handleClick } = useContactSales()

  const onSuccess = () => {
    setIsModalOpen(true)
    emitEventHandler()
  }

  return (
    <>
      {ctaLabel ? (
        <Button disabled={disabled} type={type} onClick={() => handleClick(onSuccess)}>
          {ctaLabel}
        </Button>
      ) : (
        <Button
          disabled={disabled}
          type={type}
          onClick={() => handleClick(onSuccess)}
          iconName="star"
        >
          {i18n.t('common.upgrade_now')}
        </Button>
      )}
      {isModalOpen && (
        <ContactModal isUpgrade={isUpgradeRequested} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  )
}

export default ContactButton
